// Shared heat palette for Course Matrix covers + detail view. Heat is keyed off the course's
// `start` CEFR level — cool (A1) through hot (B1+) — so an A1/A2 course automatically gets a
// different cover/detail color scheme. Shared between CourseCover.tsx and CourseDetailView.tsx
// so the cover and the chrome around it never drift apart.
export type HeatKey = 'cool' | 'warm' | 'hot';

export interface HeatPalette {
  bg: string;
  accent: string;
  badgeBg: string;
  badgeText: string;
}

export const HEAT: Record<HeatKey, HeatPalette> = {
  cool: {
    bg: 'radial-gradient(ellipse at top, #155049 0%, #0e3a36 55%, #0a2b28 100%)',
    accent: '#39e0c8',
    badgeBg: '#ff7a1a',
    badgeText: '#201004',
  },
  warm: {
    bg: 'radial-gradient(ellipse at top, #4c4a1d 0%, #2f3016 55%, #20200e 100%)',
    accent: '#f0c04b',
    badgeBg: '#ff8b1f',
    badgeText: '#201004',
  },
  hot: {
    bg: 'radial-gradient(ellipse at top, #3a2016 0%, #2a160e 55%, #1b0e07 100%)',
    accent: '#ff9e7a',
    badgeBg: '#ff5630',
    badgeText: '#2a0a0d',
  },
};

export function heatForStart(start: string): HeatKey {
  if (start === 'A1') return 'cool';
  if (start === 'A2') return 'warm';
  return 'hot';
}
